import { isEnterpriseDistribution, MODEL_VERSION } from '@/app/constants';
import type { ModelVersion } from '@/app/types';
import { FILTER_OPTION_VALUES } from '../_constants';

export interface ModelVersionFilterOption {
  key: string;
  label: string;
}

interface GetModelVersionFilterOptionsParams {
  getModelVersionText: (params: { modelVersion: ModelVersion }) => string;
}

export const getModelVersionFilterOptions = ({
  getModelVersionText,
}: GetModelVersionFilterOptionsParams): ModelVersionFilterOption[] => {
  const options: ModelVersionFilterOption[] = [
    {
      key: FILTER_OPTION_VALUES.modelVersions.q4,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.Q4 }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.q3_fast,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.Q3_FAST }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.q3_pro,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.Q3_PRO }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.q3_lite,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.Q3_LITE }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.gptImage25Fast,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.GPT_IMAGE_2_5_FAST }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.gptImage25Pro,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.GPT_IMAGE_2_5_PRO }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.gptImage2,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.GPT_IMAGE_2 }),
    },
    {
      key: FILTER_OPTION_VALUES.modelVersions.q3_a,
      label: getModelVersionText({ modelVersion: MODEL_VERSION.Q3_A }),
    },
    ...(isEnterpriseDistribution
      ? [
          {
            key: FILTER_OPTION_VALUES.modelVersions.q3_hh,
            label: getModelVersionText({ modelVersion: MODEL_VERSION.Q3_HH }),
          },
        ]
      : []),
    { key: FILTER_OPTION_VALUES.modelVersions.q3, label: 'Q3' },
    { key: FILTER_OPTION_VALUES.modelVersions.q2Pro, label: 'Q2 Pro' },
    { key: FILTER_OPTION_VALUES.modelVersions.q2, label: 'Q2' },
    { key: FILTER_OPTION_VALUES.modelVersions.q1, label: 'Q1' },
    { key: FILTER_OPTION_VALUES.modelVersions['2.0'], label: '2.0' },
    { key: FILTER_OPTION_VALUES.modelVersions['1.5'], label: '1.5' },
    { key: FILTER_OPTION_VALUES.modelVersions['1.0'], label: '1.0' },
  ];

  return options;
};
